import { StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import { LineBreak } from './LineBreak';

export interface StandaloneLineBreakProps extends StandaloneComponentProps<typeof LineBreak> {}

export const StandaloneLineBreak: StandaloneComponent<StandaloneLineBreakProps> = (props) => {
  return <LineBreak {...props} />;
};
